import React from 'react';
import ReactDOM from 'react-dom';

/* Imports :: Styles And Assets*/
import './index.css';

/* Imports :: Components*/
import App from './App';

import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './ErrorBoundary';

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
